import ApiService from "services/ApiService";

export default class AuthServices {
  static forgotPass = async (data) => {
    const instance = await ApiService();
    return instance.post("/forgotpassword", data);
  };
}
